import dates from "@/services/date";
import store from "@/store";
import company from "../../services/company";

let parseDateTime = function (value) {
  if (!value) {
    return;
  }

  return dates.jsonDateToLocaleDateTime(value, company.getLocaleFormat(store.state));
};

export default {
  install: function (Vue) {
    Vue.filter('parseDateTime', parseDateTime);
  }
}
